import React from 'react';

import { StepProps } from '@betterment/js-runtime';
import { Box, Icon, Text } from '@betterment/samba-react';
import { SambaAutoLink } from '@betterment/shared-components';
import { Button, CenteredWorkflowLayout, Heading } from '@betterment/style-closet-react';

import { FlowState } from './Controller';

import Footer from '../Shared/components/Footer';
import { locationAssign } from '../Shared/path-helpers';
import { urlBuilder } from '../Shared/urlBuilder';

interface Props extends StepProps<FlowState> {
  spendingAccountName: string;
}

const Success: React.FC<React.PropsWithChildren<Props>> = ({ flowState, spendingAccountName }) => {
  const { accountId } = flowState.values;

  if (!accountId) {
    locationAssign(flowState.basePath);
    return null;
  }

  return (
    <CenteredWorkflowLayout title="Checking signup">
      <CenteredWorkflowLayout.Slot name="content">
        <Box
          css={{
            marginBottom: 'space.200',
          }}
        >
          <Icon name="CheckmarkCircle" size="large" color="icon.success" />
        </Box>
        <Heading variant="primary">Your Checking account has been created</Heading>
        <Box
          css={{
            paddingBottom: 'space.200',
            paddingTop: 'space.100',
          }}
        >
          <Text
            css={{
              margin: 'space.0',
            }}
          >
            Your Betterment Visa&reg; Debit Card is now connected to both of your Checking accounts. It's currently set
            to spend from {spendingAccountName}, but you can always switch accounts in your Checking settings.
          </Text>
        </Box>
        <SambaAutoLink to={urlBuilder.getCheckingFundingOptions.absolute({ accountId })}>
          <CenteredWorkflowLayout.Actions>
            <Button type="button" px="8">
              Fund your account
            </Button>
          </CenteredWorkflowLayout.Actions>
        </SambaAutoLink>
      </CenteredWorkflowLayout.Slot>
      <CenteredWorkflowLayout.Slot name="footer">
        <Footer />
      </CenteredWorkflowLayout.Slot>
    </CenteredWorkflowLayout>
  );
};

export default Success;
